import { Component, OnInit, Inject, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/filter';
import { DOCUMENT } from '@angular/common';
import { LocationStrategy, PlatformLocation, Location } from '@angular/common';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { ErrorService } from './service/error.service';
import { AuthService } from './service/auth/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    private _router: Subscription;
    @ViewChild(NavbarComponent) navbar: NavbarComponent;
    errorSubscription: Subscription;
    public isConnected = false;

    constructor(
        public authService: AuthService,
        private renderer: Renderer2,
        private router: Router,
        @Inject(DOCUMENT) private document: any,
        private element: ElementRef,
        public location: Location,
        private ers: ErrorService,
    ) { }

    ngOnInit() {        
        //if (this.authService.isLoggedIn) {
            this.errorSubscription = this.ers.errorSubject.subscribe((data: any) => {
                if (data.type === 'error403') {
                    this.router.navigate(['/error403']);
                }
            });
            const navbar: HTMLElement = this.element.nativeElement.children[0].children[0];
            this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
                if (window.outerWidth > 991) {
                    window.document.children[0].scrollTop = 0;
                } else {
                    window.document.activeElement.scrollTop = 0;
                }
                this.navbar.sidebarClose();
            });
            this.renderer.listen('window', 'scroll', (event) => {
                const number = window.scrollY;
                if (number > 150 || window.pageYOffset > 150) {
                    // add logic
                    navbar.classList.remove('navbar-transparent');
                } else {
                    // remove logic
                    navbar.classList.add('navbar-transparent');
                }
            });
            const ua = window.navigator.userAgent;
            const trident = ua.indexOf('Trident/');
            const rv = ua.indexOf('rv:');
            const version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            if (version) {
                const body = document.getElementsByTagName('body')[0];
                body.classList.add('ie-background');
            }      
        //}
    }
    removeFooter() {
        let titlee = this.location.prepareExternalUrl(this.location.path());
        titlee = titlee.slice(1);
        if (titlee === 'signup' || titlee === 'nucleoicons') {
            return false;
        } else {
            return true;
        }
    }
}
